import { render } from "./list-view.vue?vue&type=template&id=2f20e9da&scoped=true&ts=true"
import script from "./list-view.vue?vue&type=script&lang=ts"
export * from "./list-view.vue?vue&type=script&lang=ts"

import "./list-view.vue?vue&type=style&index=0&id=2f20e9da&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f20e9da"]])

export default __exports__